import { useEffect, useState } from "react";
import { account_profile_status, allUsers } from "../../api/fetch";

function Provider() {
  const [allUser, setAllUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handlerefresh = () => {
    setRefresh(!refresh);
  };

  useEffect(() => {
    fetchAllUsers();
  }, [refresh]);

  const fetchAllUsers = async () => {
    setIsLoading(true);
    try {
      const res = await allUsers();
      setAllUsers(res?.data);
      setIsLoading(false);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const handleActive = async (rowData) => {
    const body = {
      id: rowData?.id,
      mobile_number: rowData?.mobile_number,
      astatus: true,
    };

    try {
      await account_profile_status(body);

      handlerefresh();
    } catch (error) {
      console.log("Eroor ::", error);
    }
  };

  const handleApprove = async (rowData) => {
    const body = {
      id: rowData?.id,
      mobile_number: rowData?.mobile_number,
      pstatus: true,
    };

    try {
      await account_profile_status(body);

      handlerefresh();
    } catch (error) {
      console.log("Error :", error);
    }
  };

  return {
    allUser,
    isLoading,
    handleActive,
    handleApprove,
  };
}

export default Provider;
